module.exports = __webpack_public_path__ + "f76a619b7d2bafcb704f6b839c95224b.svg";